import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column",
  style: {"padding":"0 25px"}
}
const _hoisted_2 = {
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseOnCall",
  class: "d-flex flex-row align-items-center cursor-pointer justify-content-between w-100"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 fs-7 fw-bold text-uppercase" }, " On Call ", -1)
const _hoisted_4 = {
  class: "collapse",
  id: "collapseOnCall"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-5 w-100"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "user-select-none d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-primary" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      version: "1.1",
      viewBox: "0 0 24 24",
      height: "24px",
      width: "24px",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Oval-5",
        fill: "#000000",
        opacity: "0.3",
        cx: "12",
        cy: "12",
        r: "10"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 Z",
        id: "Combined-Shape",
        fill: "#000000"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", { class: "text-primary fs-5 ms-2 cursor-pointer" }, "Add more")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowDown = _resolveComponent("IconArrowDown")!
  const _component_OnCallUser = _resolveComponent("OnCallUser")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_ctx.$can('can_add_on_call_user', 'all') || _ctx.onCallUsers.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.onCallUsers.length > 1)
            ? (_openBlock(), _createBlock(_component_IconArrowDown, {
                key: 0,
                style: _normalizeStyle([{"transition":"all 0.3s"}, _ctx.isCollapsed ? 'rotate: -180deg' : ''])
              }, null, 8, ["style"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.onCallUsers.length)
          ? (_openBlock(), _createBlock(_component_OnCallUser, {
              key: 0,
              onRemoveOnCall: _ctx.handleDeleteOnCall,
              data: _ctx.onCallUsers[0]
            }, null, 8, ["onRemoveOnCall", "data"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onCallUsers.slice(1), (user, index) => {
            return (_openBlock(), _createBlock(_component_OnCallUser, {
              onRemoveOnCall: _ctx.handleDeleteOnCall,
              key: index,
              data: user
            }, null, 8, ["onRemoveOnCall", "data"]))
          }), 128))
        ]),
        (_ctx.$can('can_add_on_call_user', 'all'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_popover, {
                ref: "popoverRef",
                width: "350",
                title: "Add on call user"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_autocomplete, {
                    class: "w-100",
                    placeholder: "Search user by name",
                    modelValue: _ctx.inputValue,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
                    debounce: 400,
                    size: "large",
                    teleported: false,
                    onSelect: _ctx.handleSelect,
                    "fetch-suggestions": _ctx.searchUsers
                  }, null, 8, ["modelValue", "onSelect", "fetch-suggestions"])
                ]),
                reference: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 512)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}